/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Label_Fee_OverrideInputs */

const en_label_fee_override = /** @type {(inputs: Label_Fee_OverrideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fee Override`)
};

const es_label_fee_override = /** @type {(inputs: Label_Fee_OverrideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anulación de Tarifa`)
};

const fr_label_fee_override = /** @type {(inputs: Label_Fee_OverrideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dérogation aux frais`)
};

const de_label_fee_override = /** @type {(inputs: Label_Fee_OverrideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gebührenüberschreibung`)
};

const id_label_fee_override = /** @type {(inputs: Label_Fee_OverrideInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penyesuaian Biaya`)
};

/** @type {(inputs: Label_Fee_OverrideInputs) => LocalizedString} */
const ja_label_fee_override = en_label_fee_override;

/** @type {(inputs: Label_Fee_OverrideInputs) => LocalizedString} */
const zh_label_fee_override = en_label_fee_override;

/** @type {(inputs: Label_Fee_OverrideInputs) => LocalizedString} */
const ar_label_fee_override = en_label_fee_override;

/** @type {(inputs: Label_Fee_OverrideInputs) => LocalizedString} */
const it_label_fee_override = en_label_fee_override;

/** @type {(inputs: Label_Fee_OverrideInputs) => LocalizedString} */
const ru_label_fee_override = en_label_fee_override;

/** @type {(inputs: Label_Fee_OverrideInputs) => LocalizedString} */
const pt_label_fee_override = en_label_fee_override;

/** @type {(inputs: Label_Fee_OverrideInputs) => LocalizedString} */
const ko_label_fee_override = en_label_fee_override;

/**
* | output |
* | --- |
* | "Fee Override" |
*
* @param {Label_Fee_OverrideInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const label_fee_override = /** @type {((inputs?: Label_Fee_OverrideInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Label_Fee_OverrideInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_label_fee_override(inputs)
	if (locale === "es") return es_label_fee_override(inputs)
	if (locale === "fr") return fr_label_fee_override(inputs)
	if (locale === "de") return de_label_fee_override(inputs)
	if (locale === "ja") return ja_label_fee_override(inputs)
	if (locale === "zh") return zh_label_fee_override(inputs)
	if (locale === "ar") return ar_label_fee_override(inputs)
	if (locale === "id") return id_label_fee_override(inputs)
	if (locale === "it") return it_label_fee_override(inputs)
	if (locale === "ru") return ru_label_fee_override(inputs)
	if (locale === "pt") return pt_label_fee_override(inputs)
	return ko_label_fee_override(inputs)
});